export const SEND_WHATSAPP_MSG = "SEND_WHATSAPP_MSG"
export const SEND_WHATSAPP_MSG_SUCCESS = "SEND_WHATSAPP_MSG_SUCCESS"
export const SEND_WHATSAPP_MSG_FAILED = "SEND_WHATSAPP_MSG_FAILED"